import { render, staticRenderFns } from "./switching-settings.vue?vue&type=template&id=49dd863e"
import script from "./switching-settings.vue?vue&type=script&lang=js"
export * from "./switching-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports